var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-wrap"},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.year)+" - Tabula Agency")])])}
var staticRenderFns = []

export { render, staticRenderFns }